import tinycolor from 'tinycolor2';
import { parse, format } from 'date-fns';

export const stringDateToIso = (dateString) => {
  const parsedDate = parse(dateString, 'dd/MM/yyyy', new Date())
  const formattedDate = parsedDate.toISOString()
  return formattedDate
}

export const parseDate = (dateString, stringFormat, outputFormat) => {
  const parsedDate = parse(dateString, stringFormat, new Date())
  return format(parsedDate, outputFormat)
}

export const alphaNumericLowerCase = data => data.map(tag => tag.replace(/[^\w\s]/gi, '').toLowerCase())

export const opacityToHex = (opacity) => {
  if (opacity < 0 || opacity > 1) {
    throw new Error("Opacity must be between 0 and 1")
  }
  const decimalValue = Math.round(opacity * 255)
  const hexValue = decimalValue.toString(16).padStart(2, '0').toUpperCase()
  return hexValue
}

export const hexToObject = (hex) => {
  const tc = tinycolor(hex)
  return {
    hex: tc.toHexString(),
    rgb: tc.toRgb(),
    hsl: tc.toHsl(),
    hsv: tc.toHsv()
  }
}

export const getColorFormat = (color) => {
  const tc = tinycolor(color)
  return tc.getFormat()
}

export const hex8ToHex = (string) => {
  const tc = tinycolor(string)
  return tc.toHexString()
}

export const rgbToHexAlpha = (rgb) => {
  const tc = tinycolor(rgb)
  return tc.toHex8String()
}

export const rgbaArrayToHex = (arr) => {
  if (!Array.isArray(arr) || arr.length < 3) return '#000000';

  const [r, g, b, a = 1] = arr;

  const toHex = (val) => {
    const num = Number(val);
    return Math.max(0, Math.min(255, Math.round(num)))
      .toString(16)
      .padStart(2, '0');
  };

  const alpha = Math.round(Math.max(0, Math.min(1, a)) * 255);

  return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(alpha)}`;
}
export const convert24hTo12hTime = (timeString) => {
  const parsedTime = parse(timeString, 'HH:mm', new Date());
  return format(parsedTime, 'hh:mm a');
}

export const getTextAfterLastSlash = (str) => {
  const lastSlashIndex = str.lastIndexOf('/')
  const textAfterLastSlash = str.substring(lastSlashIndex + 1)
  return textAfterLastSlash
}

export const sizeToBytes = (size) => {
  size = size.toUpperCase()

  if (size.includes('GB')) {
    return parseFloat(size.replace('GB', '').trim()) * 1024 * 1024 * 1024
  } else if (size.includes('MB')) {
    return parseFloat(size.replace('MB', '').trim()) * 1024 * 1024
  } else if (size.includes('KB')) {
    return parseFloat(size.replace('KB', '').trim()) * 1024
  } else if (size.includes('BYTES')) {
    return parseFloat(size.replace('BYTES', '').trim())
  } else {
    return -1
  }
}

export const sortFilesBySize = (files, order = 'asc') => {
  return files.sort((a, b) => {
    const sizeA = sizeToBytes(a.size)
    const sizeB = sizeToBytes(b.size)

    if (sizeA === -1) return 1
    if (sizeB === -1) return -1

    if (order === 'asc') {
      return sizeA - sizeB
    } else {
      return sizeB - sizeA
    }
  })
}